import { IPagination } from 'app/types/common';

export interface IOrganisationProductsState {
  readonly organisationProductsById?: any;
  readonly organisationProductIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrganisationProductLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrganisationProduct?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrganisationProductIds?: string[];
  readonly currentOrganisationProductId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationProductsSelector
  extends IOrganisationProductsState {
  readonly currentOrganisationProduct?: any;
  readonly currentFormOrganisationProduct?: any;
  readonly organisationProductsFilteredByOrganisationInSelectFormat?: any;
  readonly organisationProductsByTagAndIdInSelectFormat?: any;
  readonly organisationProductsByIdInSelectFormat?: any;
  readonly organisationProductsFilteredByCompetitionInSelectFormat?: any;
  readonly organisationProductsFilteredByIdInSelectFormat?: any;
}

export enum OrganisationProductsActionTypes {
  GET_ALL_ORGANISATION_PRODUCTS_REQUESTED = 'redux-app/organisation-products/GET_ALL_ORGANISATION_PRODUCTS_REQUESTED',
  GET_ALL_ORGANISATION_PRODUCTS_PENDING = 'redux-app/organisation-products/GET_ALL_ORGANISATION_PRODUCTS_PENDING',
  GET_ALL_ORGANISATION_PRODUCTS_SUCCESS = 'redux-app/organisation-products/GET_ALL_ORGANISATION_PRODUCTS_SUCCESS',
  GET_ALL_ORGANISATION_PRODUCTS_FAIL = 'redux-app/organisation-products/GET_ALL_ORGANISATION_PRODUCTS_FAIL',
  GET_ORGANISATION_PRODUCT_REQUESTED = 'redux-app/organisation-products/GET_ORGANISATION_PRODUCT_REQUESTED',
  GET_ORGANISATION_PRODUCT_PENDING = 'redux-app/organisation-products/GET_ORGANISATION_PRODUCT_PENDING',
  GET_ORGANISATION_PRODUCT_SUCCESS = 'redux-app/organisation-products/GET_ORGANISATION_PRODUCT_SUCCESS',
  GET_ORGANISATION_PRODUCT_FAIL = 'redux-app/organisation-products/GET_ORGANISATION_PRODUCT_FAIL',
  UPDATE_ORGANISATION_PRODUCT_REQUESTED = 'redux-app/organisation-products/UPDATE_ORGANISATION_PRODUCT_REQUESTED',
  UPDATE_ORGANISATION_PRODUCT_PENDING = 'redux-app/organisation-products/UPDATE_ORGANISATION_PRODUCT_PENDING',
  UPDATE_ORGANISATION_PRODUCT_SUCCESS = 'redux-app/organisation-products/UPDATE_ORGANISATION_PRODUCT_SUCCESS',
  UPDATE_ORGANISATION_PRODUCT_FAIL = 'redux-app/organisation-products/UPDATE_ORGANISATION_PRODUCT_FAIL',
  CREATE_ORGANISATION_PRODUCT_REQUESTED = 'redux-app/organisation-products/CREATE_ORGANISATION_PRODUCT_REQUESTED',
  CREATE_ORGANISATION_PRODUCT_PENDING = 'redux-app/organisation-products/CREATE_ORGANISATION_PRODUCT_PENDING',
  CREATE_ORGANISATION_PRODUCT_SUCCESS = 'redux-app/organisation-products/CREATE_ORGANISATION_PRODUCT_SUCCESS',
  CREATE_ORGANISATION_PRODUCT_FAIL = 'redux-app/organisation-products/CREATE_ORGANISATION_PRODUCT_FAIL',
  DELETE_ORGANISATION_PRODUCT_REQUESTED = 'redux-app/organisation-products/DELETE_ORGANISATION_PRODUCT_REQUESTED',
  DELETE_ORGANISATION_PRODUCT_PENDING = 'redux-app/organisation-products/DELETE_ORGANISATION_PRODUCT_PENDING',
  DELETE_ORGANISATION_PRODUCT_SUCCESS = 'redux-app/organisation-products/DELETE_ORGANISATION_PRODUCT_SUCCESS',
  DELETE_ORGANISATION_PRODUCT_FAIL = 'redux-app/organisation-products/DELETE_ORGANISATION_PRODUCT_FAIL',
  SELECT_ORGANISATION_PRODUCT_REQUESTED = 'redux-app/organisation-products/SELECT_ORGANISATION_PRODUCT_REQUESTED',
}

export default null;
